/* eslint-disable */
import { getText } from '../internal/TextLabels'
import { getCountry } from '../internal/TextLabels/text'
import { Countries } from './countries'

const inject = (str, startsWith, endsWith) => `${startsWith}${str}${endsWith}`

const governmentIdBase = (startsWith, endsWith) => ({
  SE: {
    regex: inject(
        '([0-9]{2})?([0-9]{6})[\\-+]?([0-9]{4})',
        startsWith,
        endsWith,
    ),
    get error() {
      return getText('format.governmentId.SE')
    },
  },
  DK: {
    regex: inject('([0-9]{6})[\\-]?([0-9]{3,4})', startsWith, endsWith),
    get error() {
      return getText('format.governmentId.DK')
    },
  },
  NO: {
    regex: inject('([0-9]{11})', startsWith, endsWith),
    get error() {
      return getText('format.governmentId.NO')
    },
  },
  FI: {
    regex: inject(
        '([0-9]{6})(\\+|-|A)([\\d]{3})([0-9A-Y])',
        startsWith,
        endsWith,
    ),
    get error() {
      return getText('format.governmentId.FI')
    },
  },
})
const orgNumberBase = (startsWith, endsWith) => ({
  SE: {
    regex: inject('([0-9]{2})?([0-9]{6})[\\-]?([0-9]{4})', startsWith, endsWith),
    get error() {
      return getText('format.orgNr.SE')
    },
  },
  DK: {
    regex: inject('([0-9]{2})?([0-9]{6})[\\-]?([0-9]{4})', startsWith, endsWith),
    get error() {
      return getText('format.orgNr.DK')
    },
  },
  NO: {
    regex: inject('([8-9]{1}[0-9]{8})', startsWith, endsWith),
    get error() {
      return getText('format.orgNr.NO')
    },
  },
  FI: {
    regex: inject('([0-9]{2})?([0-9]{6})[\\-]?([0-9]{4})', startsWith, endsWith),
    get error() {
      return getText('format.orgNr.FI')
    },
  },
})

export const format = {
  string: {
    regex: '^([A-Z\u00C0-\u017F\\-\\.\\,\\d a-z]{2,100})$',
    get error() {
      return getText(`format.string`)
    },
  },
  shortString: {
    regex: '^([A-Z\u00C0-\u017F\\-\\.\\,\\d a-z]{1,100})$',
    get error() {
      return getText(`format.shortString`)
    },
  },
  usernameOrEmail: {
    regex: '^([A-ZÅÄÖÜ@\\-_\\.,\\da-zåäöü]{2,100})$',
    get error() {
      return getText('format.usernameOrEmail')
    },
  },
  username: {
    regex: '^([A-ZÅÄÖÜ\\-_\\.\\da-zåäöü]{2,100})$',
    get error() {
      return getText('format.username')
    },
  },
  phone: {
    get regex() {
      switch (getCountry()) {
        case Countries.DK:
          return '^(\\+45|0045|\\+298|00298)?[ |-]?[2-9]([ |-]?[0-9]){5,7}$'
        case Countries.NO:
          return '^(\\+47|0047|)?[ |-]?[2-9]([ |-]?[0-9]){7,7}$'
        case Countries.FI:
          return '^((04[0-9]{1})(\\\\s?|-?)|050(\\\\s?|-?)|0457(\\\\s?|-?)|[\\+]?358(\\\\s?|-?)50|0358(\\\\s?|-?)50|00358(\\\\s?|-?)50|[\\+]?358(\\\\s?|-?)4[0-9]{1}|0358(\\\\s?|-?)4[0-9]{1}|00358(\\\\s?|-?)4[0-9]{1})(\\\\s?|-?)(([0-9]{3,4})(\\\\s|-)?[0-9]{1,4})$'
        case Countries.SE:
        default:
          return '^((0|\\+46|0046)[ |-]?(((70|72|73|74|76|79[0-9]{0,2})([ |-]?[0-9]){7})|((200|20|46|4[0-5,7-9][0-9]?|7[1,5,7,8]|[1-3,5-6,8-9][0-9]{0,2})([ |-]?[0-9]){5,8})))?$'
      }
    },
    get error() {
      return getText(`format.phone`)
    },
  },
  mobilePhone: {
    get regex() {
      switch (getCountry()) {
        case Countries.DK:
          return '^(?:\\+45|0045|)(([ \\-]?(2[0-9]|3[0-689]|4[0-9]|5[0-9]|6[0-69]|7[0-9]|8[126-9]|9[1-36-9])(([ \\-]?\\d){6}))|(49[ \\-]?11([ \\-]?\\d){4}))$|^(?:\\+298|00298)(([ \\-]?\\d){6})$'
        case Countries.NO:
          return '^(\\+47|0047|)?[ \\-]?[2-9]([ \\-]?[0-9]){7,7}$'
        case Countries.FI:
          return '^(?=.{1,15}$)((\\+358|00358|0)[ \\-]?([1][0][1-9]|[3][0][1-9]|71|73|[7][5][0][0][3-9]|[7][5][3][0][3-9]|[7][5][3][2][3-9]|[7][5][7][5][3-9]|[7][5][9][8][3-9]|[5][0][0-9]{0,2}|[4][0-9]{1,3})([ \\-]?[0-9]){3,10})$'
        case Countries.SE:
        default:
          return '^(((\\+46|0046)[ ]?|0)(70|72|73|76|79)([ \\-]?[0-9]){7})$'
      }
    },
    get error() {
      return getText(`format.mobilePhone`)
    },
  },
  email: {
    regex:
        "^(?=.{1,256})(?=.{0,64}@.{0,255}$)[a-zA-Z0-9!#$%&'*+\\/\\=\\?\\^_`\\{\\|\\}\\~\\-]+(?:\\.[a-zA-Z0-9!#$%&'*+\\/\\=\\?\\^_`\\{\\|\\}\\~\\-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9\\-]*[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,}$",
    get error() {
      return getText(`format.email`)
    },
  },
  governmentIdWithWhitespace: {
    ...governmentIdBase('\\s*', '\\s*'),
  },
  orgNrWithWhitespace: {
    ...orgNumberBase('\\s*', '\\s*'),
  },
  governmentId: {
    ...governmentIdBase('^', '$'),
  },
  orgNr: {
    ...orgNumberBase('^', '$'),
  },
  integer: {
    regex: '^-?([1-9]\\d*|0)$',
    get error() {
      return getText(`format.integer`)
    },
  },
  float: {
    regex: '^-?(0|[1-9]\\d*)($|[,\\.]\\d+$)',
    get error() {
      return getText(`format.float`)
    },
  },
  numbers: {
    regex: '^[0-9]{1,}([,.][0-9]{1,})?$',
    get error() {
      return getText(`format.numbers`)
    },
  },
  negativeOrPositiveNumbers: {
    regex: '^-?[0-9]{1,}([,.][0-9]{1,})?$',
    get error() {
      return getText(`format.numbers`)
    },
  },
  get zipCode() {
    switch (getCountry()) {
      case Countries.DK:
        return {
          regex: `^[0-9]{4}$`,
          get error() {
            return getText(`format.zipCode.DK`)
          },
        }
      case Countries.NO:
        return {
          regex: `^[0-9]{4}$`,
          get error() {
            return getText(`format.zipCode.NO`)
          },
        }
      case Countries.FI:
        return {
          regex: `^[0-9]{3}[\ ]?[0-9]{2}$`,
          get error() {
            return getText(`format.zipCode.FI`)
          },
        }
      case Countries.SE:
      default:
        return {
          regex: `^[0-9]{3}[\ ]?[0-9]{2}$`,
          get error() {
            return getText(`format.zipCode.SE`)
          },
        }
    }
  },
  webpage: {
    regex: `^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$`,
    get error() {
      return getText(`format.webpage`)
    },
  },
  numberWithMax2Decimal: {
    regex: `^[0-9]+(\.[0-9]{1,2})?$`,
  },
  negativeOrPositiveNumberWithMax2Decimal: {
    regex: `^-?[0-9]+(\.[0-9]{1,2})?$`,
  },
  punctuationString: {
    regex: '^([A-Z\u00C0-\u017F\\-\\.\\d!?,:; a-z]{2,100})$',
    get error() {
      return getText(`format.punctuationString`)
    },
  },
  bonusCheckNumber: {
    regex:
        "^(\\d{16})|(\\d{4}\\s\\d{4}\\s\\d{4}\\s\\d{4})$",
    get error() {
      return getText(`format.bonusCheck`)
    },
  },
  gekasBonusCheckNumber: {
    regex:
    "^(5563)([0-9]{7})([0-9]{4})",
    get error() {
      return getText('format.bonusCheck')
    }
  }
}
